import { render, staticRenderFns } from "./ListCategories.vue?vue&type=template&id=61324586&scoped=true&"
import script from "./ListCategories.vue?vue&type=script&lang=js&"
export * from "./ListCategories.vue?vue&type=script&lang=js&"
import style0 from "./ListCategories.vue?vue&type=style&index=0&id=61324586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61324586",
  null
  
)

export default component.exports